import cs from '../../resources/translations/cs-CZ.json';
import de from '../../resources/translations/de-DE.json';
import en from '../../resources/translations/en-US.json';
import hr from '../../resources/translations/hr-HR.json';
import pl from '../../resources/translations/pl-PL.json';
import sk from '../../resources/translations/sk-SK.json';
import sl from '../../resources/translations/sl-SI.json';
const availableLocales = [
    'cs-CZ',
    'de-DE',
    'en-US',
    'hr-HR',
    'pl-PL',
    'sk-SK',
    'sl-SI',
];
const baseTranslations = {
    'cs-CZ': cs,
    'de-DE': de,
    'en-US': en,
    'hr-HR': hr,
    'pl-PL': pl,
    'sk-SK': sk,
    'sl-SI': sl,
};
export default class Localization {
    translations;
    defaultLocale;
    constructor(extraTranslations, defaultLocale) {
        const entries = Object.keys(extraTranslations).map((key) => [
            key, {
                ...baseTranslations[key],
                ...extraTranslations[key],
            }
        ]);
        this.translations = Object.fromEntries(entries);
        this.defaultLocale = defaultLocale in this.translations
            ? defaultLocale
            : Object.keys(this.translations)[0] ?? 'en-US';
    }
    get locales() {
        return Object.keys(this.translations);
    }
    isLocale(maybeLocale) {
        return this.locales.find((locale) => locale === maybeLocale) !== undefined;
    }
    findLocaleByLangCode(code) {
        return this.locales.find((locale) => locale.split('-')[0] === code) ?? null;
    }
    selectTranslations(locale) {
        const messages = this.translations[locale];
        if (messages === undefined) {
            return {
                defaultLocale: this.defaultLocale,
                locale: this.defaultLocale,
                messages: this.translations[this.defaultLocale]
            };
        }
        window.localStorage.setItem('ui-locale', locale);
        return { defaultLocale: this.defaultLocale, locale, messages };
    }
    selectTranslationsByBrowser() {
        const storedLocale = window.localStorage.getItem('ui-locale');
        if (storedLocale !== null && this.isLocale(storedLocale)) {
            return this.selectTranslations(storedLocale);
        }
        if (this.isLocale(navigator.language)) {
            return this.selectTranslations(navigator.language);
        }
        const langCode = navigator.language.split('-')[0];
        const locale = this.findLocaleByLangCode(langCode);
        if (locale !== null) {
            return this.selectTranslations(locale);
        }
        return {
            defaultLocale: this.defaultLocale,
            locale: this.defaultLocale,
            messages: this.translations[this.defaultLocale]
        };
    }
}
